(function () {
	function init() {
		var items = document.querySelectorAll(
			'.headerCollectionsNav__item--hasSubmenu'
		);
		if (!items.length) return;

		function closeAll(exceptItem) {
			items.forEach(function (item) {
				if (exceptItem && item === exceptItem) return;
				item.classList.remove('is-open');
				var btn = item.querySelector('.headerCollectionsNav__toggle');
				if (btn) btn.setAttribute('aria-expanded', 'false');
			});
		}

		items.forEach(function (item) {
			var btn = item.querySelector('.headerCollectionsNav__toggle');
			if (!btn) return;
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var open = item.classList.toggle('is-open');
				btn.setAttribute('aria-expanded', open ? 'true' : 'false');
				if (open) closeAll(item);
			});
		});

		document.addEventListener('click', function (e) {
			var inside = e.target.closest('.headerCollectionsNav__item--hasSubmenu');
			if (!inside) closeAll();
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') closeAll();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
